import React, { useCallback } from "react";
import { Box, Typography } from "@mui/material";
import vsDarkTheme from "../theme/vsDarkTheme";
import jobs from "../data/jobs";
import TypewriterText from "../components/TypewriterText";
import TypewriterHeader from "../components/TypewriterHeader";

const Resume = () => {
  const handleJobComplete = useCallback((jobIndex) => {
    // Could be used for future features like tracking completion
    console.log(`Job ${jobIndex} completed`);
  }, []);

  return (
    <Box p={{ xs: 1, sm: 2 }}>
      <TypewriterHeader title="Resume" speed={80} delay={200} />
      <Box sx={{ ml: { xs: 1, sm: 2 } }}>
        <Typography 
          variant="body1" 
          sx={{ 
            fontSize: { xs: '0.875rem', sm: '1rem' },
            lineHeight: 1.6
          }}
        >
          <span style={{ color: vsDarkTheme.palette.keyword.main }}>{`switch(`}</span>workExperience<span style={{ color: vsDarkTheme.palette.keyword.main }}>{`) `}</span><span style={{ color: vsDarkTheme.palette.comment.main }}>&#123;</span>
        </Typography>
        {jobs.map((job, index) => (
          <Box key={index} sx={{ mt: 2 }}>
            <Typography 
              variant="body2" 
              sx={{ 
                color: vsDarkTheme.palette.primary.main,
                fontSize: { xs: '0.75rem', sm: '0.875rem' }
              }}
            >
              <span style={{ color: vsDarkTheme.palette.keyword.main, paddingLeft: { xs: '10px', sm: '20px' } }}>{`case `}</span>
              <span style={{ color: vsDarkTheme.palette.string.main }}>'{job.company}'</span>:<br />
              <span style={{ color: vsDarkTheme.palette.keyword.main, paddingLeft: { xs: '20px', sm: '40px' } }}>return</span>{" {"}<br />
            </Typography>
            <Typography 
              variant="body2" 
              sx={{ 
                color: vsDarkTheme.palette.comment.main,
                fontSize: { xs: '0.75rem', sm: '0.875rem' }
              }} 
              style={{ paddingLeft: { xs: '10px', sm: '20px' } }}
            >
              <label style={{ 
                paddingLeft: { xs: '30px', sm: '60px' }, 
                color: vsDarkTheme.palette.text.primary,
                display: 'block'
              }}>Title:</label> 
              <span style={{ 
                color: vsDarkTheme.palette.string.main,
                wordBreak: 'break-word',
                display: 'block',
                paddingLeft: { xs: '30px', sm: '60px' }
              }}>"{job.title}"</span><span style={{ color: vsDarkTheme.palette.text.primary}}>,</span>
            </Typography>
            <Typography 
              variant="body2" 
              sx={{ 
                color: vsDarkTheme.palette.comment.main,
                fontSize: { xs: '0.75rem', sm: '0.875rem' }
              }} 
              style={{ paddingLeft: { xs: '10px', sm: '20px' } }}
            >
              <label style={{ 
                paddingLeft: { xs: '30px', sm: '60px' }, 
                color: vsDarkTheme.palette.text.primary,
                display: 'block'
              }}>Duration:</label> 
              <span style={{ 
                color: vsDarkTheme.palette.string.main,
                wordBreak: 'break-word',
                display: 'block',
                paddingLeft: { xs: '30px', sm: '60px' }
              }}>"{job.duration}"</span><span style={{ color: vsDarkTheme.palette.text.primary}}>,</span>
            </Typography>
            <Typography 
              variant="body2" 
              sx={{ 
                color: vsDarkTheme.palette.comment.main,
                fontSize: { xs: '0.75rem', sm: '0.875rem' }
              }} 
              style={{ paddingLeft: { xs: '10px', sm: '20px' } }}
            >
              <label style={{ 
                paddingLeft: { xs: '30px', sm: '60px' }, 
                color: vsDarkTheme.palette.text.primary,
                display: 'block'
              }}>Description:</label> 
            </Typography>
            <Box sx={{ 
              paddingLeft: { xs: '30px', sm: '60px' },
              display: 'block'
            }}>
              <span style={{ color: vsDarkTheme.palette.string.main }}>"</span>
              <TypewriterText
                text={job.description}
                speed={15}
                delay={1500 + (index * 2500)} // Stagger the typing effect
                sx={{
                  color: vsDarkTheme.palette.string.main,
                  display: 'inline',
                  fontSize: { xs: '0.75rem', sm: '0.875rem' },
                  wordBreak: 'break-word'
                }}
                onComplete={() => handleJobComplete(index)}
              />
              <span style={{ color: vsDarkTheme.palette.string.main }}>"</span>
            </Box>
            <Typography 
              variant="body2" 
              sx={{ 
                color: vsDarkTheme.palette.primary.main,
                fontSize: { xs: '0.75rem', sm: '0.875rem' }
              }} 
              style={{ paddingLeft: { xs: '20px', sm: '40px' } }}
            >
              {"}"}<span style={{ color: vsDarkTheme.palette.text.primary}}>;</span>
            </Typography>
          </Box>
        ))}
        <Typography 
          variant="body1" 
          sx={{ 
            color: vsDarkTheme.palette.comment.main, 
            paddingLeft: { xs: '10px', sm: '20px' },
            fontSize: { xs: '0.875rem', sm: '1rem' }
          }}
        >
          &#125;
        </Typography>
      </Box>
    </Box>
  );
};

export default Resume;
